// extracted by mini-css-extract-plugin
export default {"form":"styles_form__EdPde","input":"styles_input__1zjwM","photoContainer":"styles_photoContainer__y9o7i","image":"styles_image__zRJCP"};